import { User } from '../../user/user.model';
import { CoachingCoverageContext } from '../coaching-coverage/coaching-coverage.model';
import { FLOAPerson } from '../oa/models/floa.model';

import { defaultSummaryKpi } from './function/default-summary-kpi.function';
import { defaultViewSummaryPeriodType } from './function/default-view-summary-period-type.function';
import { InsightsSummaryDataKpi } from './model/insights-summary-data-kpi.model';
import { ViewSummaryPeriodType } from './model/view-summary-period-type.model';

export interface RootState {
    pending: {
        reload?: boolean;
    };

    // TODO revise. this is temporary means of flushing tabs after auth user has changed
    authUserId?: number;

    didInit?: boolean;
    kpis?: InsightsSummaryDataKpi[];
    periodTypes?: ViewSummaryPeriodType[];
    selectedPeriodType?: ViewSummaryPeriodType;
    selectedKpi?: InsightsSummaryDataKpi;
    user?: User;
    userImage?: string;
    coverageContext?: CoachingCoverageContext;
    oaUser?: FLOAPerson;
}

export const defaultState = (): RootState => ({
    pending: {},
    selectedPeriodType: defaultViewSummaryPeriodType(),
    selectedKpi: defaultSummaryKpi(),
});
